import template from "./pCasemanPgConfig.html";

export function pCasemanPgConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanPgConfigController,
    controllerAs: 'pCasemanPgConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanPgConfigController {
  constructor($scope, $location, $interval, $q, Auth, Caseman, Notes, Sort, Utils, bModal, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.ConnectionQuality = ConnectionQuality;
    this.bModal = bModal;
    this.state = "loading";
    this.addExceptionModal = false;
    this.newExceptionPG = null;
    this.processesToChoose = null;
    this.newExceptionProcess = null;
    this.newExceptionJobCode = null;

    this.headers = [
      {name: "CASEMAN.PROCESS_GROUP_KLIX", class: "table-info"},
      {name: "CASEMAN.JOBCODE_CASEMAN", class: "table-caseman"},
    ];

    this.headersInterrupts = [
      {name: "CASEMAN.INTERRUPT_KLIX", class: "table-info"},
      {name: "CASEMAN.JOBCODE_CASEMAN", class: "table-caseman"},
    ];

    this.headersExceptions = [
      {name: "CASEMAN.PROCESS_FOR_PG", class: "table-info"},
      {name: "CASEMAN.JOBCODE_CASEMAN", class: "table-caseman"}
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => { this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        let promises = [
          this.Caseman.getCountryProcessGroups(),
          this.Caseman.getCountryInterrupts(),
          this.Caseman.getProcessMappers(),
          this.Caseman.getCountryProcesses(),
          this.Caseman.getCountryProcessExceptionMappers(),
          this.Caseman.getCountryCasemanJobcodesAndSubcodes()
        ];

        this.$q.all(promises).then(
          (success) => {
            this.processGroupsKlix = success[0].data.sort(this.Sort.abcBy("name"));
            this.interruptsKlix = success[1].data.sort(this.Sort.abcBy("name"));
            this.processMappers = success[2].data;
            this.processes = success[3].data.sort(this.Sort.abcBy("name"));
            this.exceptions = success[4].data
              .map(exception => {
                const processGroupCountryConfigurationId = this.processes.find(process => process.id === exception.processId).processGroupCountryConfigurationId;
                exception.processGroupName = this.processGroupsKlix.find(pg => pg.id === processGroupCountryConfigurationId).name;
                return exception;
              })
              .sort(this.Sort.abcBy("processGroupName", "processName"));
            this.jobcodesCASEMAN = success[5].data.sort(this.Sort.abcBy("name")).map((jobcode)=> {
              jobcode.info = jobcode.name + " [id: " + jobcode.id + "]";
              return jobcode;
            });

            this.refresh();
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  refresh() {
    this.Caseman.getCountryProcessGroupsMappers().then(
      (success) => {
        this.mapper = success.data; // interruptCountryConfigurationId, processGroupCountryConfigurationId, processGroupCountryConfigurationName, jobCodeId, jobCodeName, country
        this.processGroupsMapper = this.mapper.filter(mapper => mapper.processGroupCountryConfigurationId && mapper);
        this.interruptsMapper = this.mapper.filter(mapper => mapper.interruptCountryConfigurationId && mapper);

        this.mapperToDisplay = this.processGroupsKlix && this.processGroupsKlix.map( pgKlix => {
          let client = this.processGroupsMapper && this.processGroupsMapper.find(pgMapper => pgMapper.processGroupCountryConfigurationId == pgKlix.id);
          if(!client) {
            client = {processGroupCountryConfigurationId: pgKlix.id , processGroupCountryConfigurationName: pgKlix.name, jobCodeId: null, jobCodeName: null, unmatched: true};
          }
          return client;
        });

        this.interruptMapperToDisplay = this.interruptsKlix && this.interruptsKlix.map( interruptKlix => {
          let client = this.interruptsMapper && this.interruptsMapper.find(interruptMapper => interruptMapper.interruptCountryConfigurationId == interruptKlix.id);
          if(!client) {
            client = {interruptCountryConfigurationId: interruptKlix.id , interruptName: interruptKlix.name, jobCodeId: null, jobCodeName: null, unmatched: true};
          }
          return client;
        });
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.state = "loaded";
      },
      (error) => {
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  back() {
    window.history.back();
  }

  viewProcesses(mapper) {
    this.$location.path('/caseman/config/processGroups/'+ mapper.processGroupCountryConfigurationId + '/name/' + encodeURIComponent(mapper.processGroupCountryConfigurationName) + '/jobcode/' + mapper.jobCodeId + '/country/' + mapper.country);
  }

  editMatch(entity) {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.processMatch = {info: entity.jobCodeName, name: entity.jobCodeName, id: entity.jobCodeId, country: entity.country};
  }

  doSaveMatch(pg, jobcodeToMatch, mappersToBeDeleted) {
    this.state = "loading";
    Promise.all(mappersToBeDeleted.map(m => this.Caseman.deleteProcessMatch(m.id))).then(() => {
      return this.Caseman.setCountryProcessGroupMapper(pg.interruptCountryConfigurationId, pg.processGroupCountryConfigurationId, angular.fromJson(jobcodeToMatch).id, angular.fromJson(jobcodeToMatch).country);
    }).then(
      () => {
        this.processMatch = null;
        this.processMappers = this.processMappers.filter(mapper => mappersToBeDeleted.find(m => m.id == mapper.id) == undefined);
        this.refresh();
      },
      (error) => {
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  saveMatch(pg, jobcodeToMatch) {
    const mappersToBeDeleted = this.mappersToBeDeleted(pg);
    if (mappersToBeDeleted.length > 0) {
      this.modalConfig = {
        text: "Existing customization rules for " + (pg.interruptName || pg.processGroupCountryConfigurationName) + " can be overwritten: " + this.mappersToBeDeletedMessage(mappersToBeDeleted) + ". By pressing SAVE customizations made by above mentioned users will not be affected. For overwriting these customizations press SAVE & OVERWRITE.",
        cancelText: "Cancel",
        acceptText: "Save & overwrite",
        rejectText: "Save"
      };
      this.bModal.show(this.modalConfig).then(() => {
        this.doSaveMatch(pg, jobcodeToMatch, mappersToBeDeleted);
      }, (rejected) => {
        if (rejected) {
          this.doSaveMatch(pg, jobcodeToMatch, []);
        } else {
          this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        }
      });
    } else {
      this.doSaveMatch(pg, jobcodeToMatch, []);
    }
  }

  mappersToBeDeleted(pg) {
    return this.processMappers.filter(mapper =>
      (mapper.processGroupCountryConfigurationId && pg.processGroupCountryConfigurationId == mapper.processGroupCountryConfigurationId) ||
      (mapper.interruptId && this.interruptsKlix.find(i => i.id == pg.interruptCountryConfigurationId)?.interruptId == mapper.interruptId));
  }
  

  mappersToBeDeletedMessage(mappers) {
    var groupBy = function(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };
    

    return Object.entries(groupBy(mappers, "userName")).map(([userName, mappers]) => { return userName + " (" + mappers.map(m => m.clientName).join(", ")  + ")"; }).join("; ");
  }

  doEditMatch(pg, jobcodeToMatch, mappersToBeDeleted) {
    this.state = "loading";
    Promise.all(mappersToBeDeleted.map(m => this.Caseman.deleteProcessMatch(m.id))).then(() => {
      return this.Caseman.editCountryProcessGroupMapper(pg.id, pg.interruptCountryConfigurationId, pg.processGroupCountryConfigurationId, angular.fromJson(jobcodeToMatch).id, angular.fromJson(jobcodeToMatch).country);
    }).then(
      () => {
        this.processMatch = null;
        this.processMappers = this.processMappers.filter(mapper => mappersToBeDeleted.find(m => m.id == mapper.id) == undefined);
        this.refresh();
      },
      (error) => {
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  saveEdit(pg, jobcodeToMatch) {
    const mappersToBeDeleted = this.mappersToBeDeleted(pg);
    if (mappersToBeDeleted.length > 0) {
      this.modalConfig = {
        text: "Existing customization rules for " + (pg.interruptName || pg.processGroupCountryConfigurationName) + " can be overwritten: " + this.mappersToBeDeletedMessage(mappersToBeDeleted) + ". By pressing SAVE customizations made by above mentioned users will not be affected. For overwriting these customizations press SAVE & OVERWRITE.",
        cancelText: "Cancel",
        acceptText: "Save & overwrite",
        rejectText: "Save"
      };
      this.bModal.show(this.modalConfig).then(() => {
        this.doEditMatch(pg, jobcodeToMatch, mappersToBeDeleted);
      }, (rejected) => {
        if (rejected) {
          this.doEditMatch(pg, jobcodeToMatch, []);
        } else {
          this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        }
      });
    } else {
      this.doEditMatch(pg, jobcodeToMatch, []);
    }
  }

  deleteMatch(mapper) {
    this.state = "loading";
    this.Caseman.deleteCountryProcessGroupMapper(mapper.id).then(
      () => {
        this.refresh();
      },
      (error) => {
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  cancel() {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.processMatch = null;
  }

  selectedPG() {
    this.processesToChoose = this.processes
      .filter(process => process.processGroupCountryConfigurationId === this.newExceptionPG)
      .filter(process => !this.exceptions.map(exception => exception.processId).includes(process.id));

    this.newExceptionProcess = null;
  }

  refreshExceptions() {
    this.Caseman.getCountryProcessExceptionMappers().then(
      (success) => {
        this.state = "loaded";
        this.exceptions = success.data
          .map(exception => {
            const processGroupCountryConfigurationId = this.processes.find(process => process.id === exception.processId).processGroupCountryConfigurationId;
            exception.processGroupName = this.processGroupsKlix.find(pg => pg.id === processGroupCountryConfigurationId).name;
            return exception;
          })
          .sort(this.Sort.abcBy("processGroupName", "processName"));

        if (this.addExceptionModal)
          this.closeModal();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  addException() {
    this.state = "loading";
    const data = {
      processId: this.newExceptionProcess,
      jobCodeId: parseInt(this.newExceptionJobCode.id),
      country: this.jobcodesCASEMAN[0].country
    };

    this.Caseman.saveException(data).then(
      () => this.refreshExceptions(),
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  clearNewException() {
    this.newExceptionPG = null;
    this.newExceptionProcess = null;
    this.newExceptionJobCode = null;
  }

  closeModal() {
    this.addExceptionModal = false;
    this.clearNewException();
  }

  saveException(exception) {
    this.state = "loading";
    const data = {
      processId: exception.processId,
      jobCodeId: parseInt(this.exceptionProcessMatch.id),
      country: exception.country
    };

    this.Caseman.saveException(data).then(
      () => {
        this.closeException(exception);
        this.refreshExceptions();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  closeException(exception) {
    delete exception.edited;

    this.exceptions.forEach(exception => {
      if (exception.blocked)
        delete exception.blocked;
    });

    this.exceptionProcessMatch = null;
  }

  editException(exception) {
    this.exceptions.forEach(exc => {
      if (exc.processId !== exception.processId)
        exc.blocked = true;
      else
        exc.edited = true;
    });

    this.exceptionProcessMatch = {
      info: `${exception.jobCodeName} ${exception.jobCodeId && '[id: ' + exception.jobCodeId + ']'}`,
      name: exception.jobCodeName,
      id: exception.jobCodeId,
      country: exception.country
    };
  }

  deleteException(exception) {
    this.state = "loading";
    this.Caseman.deleteException(exception.processId).then(
      () => this.refreshExceptions(),
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  findPGName(processId) {
    const PGConfId = this.processes.find(process => process.id === processId).processGroupCountryConfigurationId;
    return this.processGroupsKlix.find(pg => pg.id === PGConfId).name;
  }
}